module.exports = __webpack_public_path__ + "app/img/Android.7c67da3ef4.svg";